<template>
  <!-- 二级页面banner -->
  <div
    class="secondary-banner-index"
    :style="{ height: height, backgroundImage: `url(${bgImage})` }"
  >
    <div class="content">
      <div
        class="iconBox"
        v-scroll-animate="{
          animation: 'fadeInDown',
          observerOnce: false,
          duration: 600,
        }"
      >
        <img class="img" :src="icon" alt="" />
        <div class="icon-title" v-if="iconText">{{ iconText }}</div>
      </div>
      <div
        class="title"
        v-if="title"
        v-scroll-animate="{
          animation: 'fadeInDown',
          observerOnce: false,
          duration: 600,
        }"
      >
        {{ title }}
      </div>
      <div
        class="sub-title text-wrap"
        v-if="subTitle"
        v-scroll-animate="{
          animation: 'fadeInDown',
          observerOnce: false,
          duration: 500,
          delay: 400,
        }"
      >
        {{ subTitle }}
      </div>
      <div
        class="btn"
        v-if="downLoadBtn.length > 0"
        v-scroll-animate="{
          animation: 'fadeInDown',
          observerOnce: false,
          duration: 500,
          delay: 400,
        }"
      >
        <DownLoad
          v-for="(item, index) in downLoadBtn"
          :key="index"
          class="margin-right-20"
          :btnLabel="item.label"
          :fileUrl="item.fileUrl"
          :fileName="item.fileName"
        />
      </div>
      <!-- 展示视频 -->
      <div
        class="video"
        v-if="videoUrl"
        v-scroll-animate="{
          animation: 'fadeInUp',
          observerOnce: false,
          duration: 500,
          delay: 400,
        }"
      >
        <!-- <video :url="videoUrl" /> -->
        <template v-if="posterImg">
          <video controls :poster="posterImg" autoplay>
            <source :src="videoUrl" type="video/mp4" />
          </video>
        </template>
        <template v-else>
          <video controls autoplay>
            <source :src="videoUrl" type="video/mp4" />
          </video>
        </template>
      </div>
      <!-- 视频切换按钮 -->
      <!-- <div class="videoChangeBtn">
        <el-button
          type="text"
          @click="changeVideo(item)"
          v-for="(item, index) in changeVideoList"
          :key="'changeVideo_' + index"
          :class="{ active: item.value === videoUrl }"
        >
          {{ item.name }}
        </el-button>
      </div> -->
      <!-- 展示图片 -->
      <div class="picture-box" v-if="pictureUrl">
        <div
          class="picture"
          v-scroll-animate="{
            animation: 'fadeInUp',
            observerOnce: false,
            duration: 500,
            delay: 400,
          }"
        >
          <img :src="pictureUrl" alt="" srcset="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DownLoad from "@/components/DownLoad";
export default {
  props: {
    height: {
      type: String,
      default: () => {
        return "944px";
      },
    },
    bgImage: {
      type: String,
      default: () => {
        return require("@/assets/images/digitalImg/airoad_bg.png");
      },
    },
    icon: {
      type: String,
      default: () => {
        return require("@/assets/images/digitalImg/airoad_icon.png");
      },
    },
    // 图标右侧侧文案
    iconText: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "",
    },
    subTitle: {
      type: String,
      default: "",
    },
    downLoadBtn: {
      type: Array,
      default: () => {
        return [];
      },
    },
    posterImg: {
      type: String,
      default: "",
    },
    videoUrl: {
      type: String,
      default: "",
    },
    pictureUrl: {
      type: String,
      default: "",
    },
  },
  components: { DownLoad },
  data() {
    return {};
  },
  created() {
    console.log("downLoadBtn", this.downLoadBtn);
  },
  methods: {
    downLoadFile() {
      // 按钮事件
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/common.scss";
.secondary-banner-index {
  width: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  .content {
    width: 1048px;
    margin: 0 auto;
    padding: 40px 0;
    box-sizing: border-box;
    .iconBox {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-top: 20px;
      margin-bottom: 16px;
      .icon-title {
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        color: #ffffff;
        margin-left: 20px;
      }
      .img {
        height: 32px;
      }
    }

    .title {
      padding: 24px 0 12px;
      font-weight: 600;
      font-size: 24px;
      line-height: 24px;
      color: #ffffff;
    }
    .sub-title {
      font-weight: 400;
      font-size: 14px;
      line-height: 14px;
      color: #ffffff;
      margin: 8px 0 32px 0;
    }
    .btn {
      margin-bottom: 40px;
      ::v-deep .el-button {
        border-color: #ffffff;
        color: #ffffff;
        background: transparent;
        &:hover {
          background: transparent;
          border-color: #0035fb;
          color: #0035fb;
        }
        &:focus {
          border-color: #ffffff;
          color: #ffffff;
          background: transparent;
        }
      }
    }

    .video {
      width: 100%;
      height: 590px;
      padding: 10px;
      box-sizing: border-box;
      background: #1d1d1d;
      border-radius: 8px;
      border: 1px solid #454545;
      video {
        width: 100%;
        height: 100%;
      }
    }
    .picture-box {
      width: 1046px;
      height: 602px;
      border: 1px solid rgba(255, 255, 255, 0.2);
      border-radius: 8px;
      background-color: rgba(219, 219, 219, 0.1);
      padding: 16px;
      margin-top: 24px;
      .picture {
        width: 100%;
        height: 100%;
      }
    }
  }
  .margin-right-20 {
    margin-right: 20px;
  }
}
</style>